import { Alert, Button, Card, Collapse, Descriptions, Form, Input, InputNumber, Modal, Tabs, Tag } from 'antd'
import { EmailAddressApi } from 'api/EmailAddress'
import FooterButtons from 'elements/Buttons/FooterButtons'
import useFetch from 'elements/Hooks/useFetch'
import useModalShow from 'elements/Hooks/useModalShow'
import useSubmit from 'elements/Hooks/useSubmit'
import { get, pick } from 'lodash'
import { fullWidthFormItemLayout } from 'modules/FormItems'
import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import CustomTable from '../../../elements/Table/CustomTable'

function EmailAddressList(props) {
  const { data: list, fetching, fetch } = useFetch({
    url: '/emailAddress',
  })

  const { visible, onShow: _onShow, onCancel: _onCancel, isNew } = useModalShow()
  const [current, setCurrent] = useState({})

  function onShow(object, type) {
    console.log(object, type)
    setCurrent(object)
    _onShow(object, type)
  }

  function onCancel(props) {
    setCurrent({})
    _onCancel(props)
  }

  const [submitting, submitFunc] = useSubmit(EmailAddressApi.create)
  const [updating, updateFunc] = useSubmit(EmailAddressApi.update)
  const [removing, removeFunc] = useSubmit(EmailAddressApi.remove)

  async function submit() {
    const submitted = await submitFunc(current)
    if (submitted) {
      onCancel()
      fetch()
    }
  }

  async function remove() {
    const removed = await removeFunc({
      ...pick(current, ['_key', '_rev', '_id']),
    })
    if (removed) {
      onCancel()
      fetch()
    }
  }

  async function update() {
    const submitted = await updateFunc(current)
    if (submitted) {
      onCancel()
      fetch()
    }
  }

  const columns = [
    {
      Header: 'Title',
      accessor: 'name',
      width: 150,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Body',
      accessor: 'emails',
      Cell: ({ value }) => (
        <span>
          {value.map((i) => (
            <Tag color="#2db7f5">{i}</Tag>
          ))}
        </span>
      ),
    },
  ]

  console.log(current)

  return (
    <>
      <Modal
        footer={
          <FooterButtons
            isNew={isNew}
            isEdit={!isNew}
            submit={submit}
            remove={remove}
            update={update}
            removing={removing}
            submitting={submitting || updating}
            title={'Email List'}
          />
        }
        title="Email List"
        width="90%"
        onCancel={onCancel}
        destroyOnClose
        visible={visible}>
        <Form.Item {...fullWidthFormItemLayout} label="Name">
          <Input
            defaultValue={get(current, 'name')}
            onChange={(e) =>
              setCurrent({
                ...current,
                name: e.target.value,
              })
            }
          />
        </Form.Item>

        <Form.Item {...fullWidthFormItemLayout} label="Email">
          <Input.TextArea
            rows={10}
            defaultValue={get(current, 'emails', []).join(', ')}
            onChange={(e) =>
              setCurrent({
                ...current,
                emails: e.target.value.split(', '),
              })
            }
          />
          <Alert message="Separate Emails by comma" type="info" />
        </Form.Item>

        <Collapse accordion defaultActiveKey={['1']}>
          <Collapse.Panel header="Current Emails" key="1">
            <span>
              {current?.emails?.map((i) => (
                <Tag color="#2db7f5">{i}</Tag>
              ))}
            </span>
          </Collapse.Panel>
        </Collapse>
      </Modal>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        CreateButton={() => (
          <Button type="primary" onClick={() => onShow()}>
            New Email List
          </Button>
        )}
        columns={columns}
        defaultSorted={[
          {
            id: '_key',
            desc: false,
          },
        ]}
      />
    </>
  )
}

export default EmailAddressList
